import { render, staticRenderFns } from "./TabAccommodationPackage.vue?vue&type=template&id=cdb1e94c"
import script from "./TabAccommodationPackage.vue?vue&type=script&lang=ts"
export * from "./TabAccommodationPackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports